// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   Code,
//   Database,
//   Layers,
//   Rocket,
//   Shield,
//   Workflow,
//   Users,
//   Terminal,
//   Server,
//   CheckCircle2,
// } from "lucide-react";

// const PHPProgramming = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1200, once: false });
//   }, []);

//   return (
//     <div className="font-sans">
//       {/* Hero Section */}
//       <section
//         className="relative text-white py-20 px-6 md:px-20 bg-cover bg-center"
//         style={{
//           backgroundImage:
//             "url('https://i.pinimg.com/originals/64/6c/ef/646cef51a0e8d46d5eac1f79f1a15a4f.jpg')",
//         }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-r from-indigo-800/80 via-purple-800/70 to-pink-700/80"></div>
//         <div className="relative flex flex-col md:flex-row items-center gap-10">
//           <div className="md:w-1/2" data-aos="fade-right">
//             <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6 text-yellow-300 animate-bounce mt-5">
//               Master PHP Programming
//             </h1>
//             <p className="text-lg md:text-xl mb-8 text-gray-100">
//               Learn PHP from scratch to advanced concepts. Build dynamic
//               websites, work with databases, and develop professional web
//               applications that power the internet.
//             </p>
//             <button className="bg-yellow-400 hover:bg-yellow-500 text-black px-8 py-3 rounded-xl font-semibold shadow-lg transition-transform transform hover:scale-110 animate-pulse">
//               🚀 Enroll Now
//             </button>
//           </div>
//           <div className="md:w-1/2" data-aos="fade-left">
//             <img
//               src="https://static.vecteezy.com/system/resources/previews/003/665/772/large_2x/php-coding-concept-programmer-search-technology-background-photo.jpg"
//               alt="PHP Programming"
//               className="rounded-2xl shadow-2xl animate-float"
//             />
//           </div>
//         </div>
//       </section>

//       {/* What is PHP */}
//       <section className="py-20 px-6 md:px-20 bg-gray-50 flex justify-center">
//         <div
//           className="bg-indigo-50 shadow-lg rounded-2xl p-8 max-w-4xl transition-transform transform hover:-translate-y-2 hover:shadow-2xl animate-fade-in"
//           data-aos="fade-up"
//         >
//           <h2 className="text-4xl font-bold text-center text-black mb-8">
//             What is PHP Programming?
//           </h2>
//           <p className="text-lg text-gray-700 leading-relaxed">
//             <span className="font-semibold text-purple-700">PHP</span>{" "}
//             (Hypertext Preprocessor) is a powerful server-side scripting
//             language widely used for web development. It powers millions of
//             websites and applications, enabling developers to create dynamic
//             content, manage databases, and build scalable web solutions. This
//             course takes you from beginner to professional, covering basics,
//             advanced topics, and frameworks like{" "}
//             <span className="text-indigo-700 font-semibold">Laravel</span>.
//           </p>
//         </div>
//       </section>

//       {/* Course Outcomes */}
//       <section className="py-20 px-6 md:px-20 bg-gradient-to-r from-gray-100 via-gray-50 to-white">
//         <h2
//           className="text-4xl font-bold text-center text-black mb-14"
//           data-aos="zoom-in"
//         >
//           Course Outcomes
//         </h2>
//         <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
//           <div
//             className="bg-blue-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-bounce"
//             data-aos="flip-left"
//           >
//             <Code className="mx-auto w-12 h-12 text-indigo-600 mb-4 animate-spin-slow" />
//             <h3 className="text-xl font-bold text-black mb-2">
//               Hands-on Projects
//             </h3>
//             <p className="text-gray-700">
//               Build dynamic websites and web applications using PHP and MySQL.
//             </p>
//           </div>
//           <div
//             className="bg-pink-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-jump"
//             data-aos="flip-up"
//           >
//             <Rocket className="mx-auto w-12 h-12 text-pink-600 mb-4 animate-bounce" />
//             <h3 className="text-xl font-bold text-black mb-2">Career Ready</h3>
//             <p className="text-gray-700">
//               Prepare for roles like PHP Developer, Backend Engineer, and Full
//               Stack Web Developer.
//             </p>
//           </div>
//           <div
//             className="bg-yellow-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-shake"
//             data-aos="flip-right"
//           >
//             <Layers className="mx-auto w-12 h-12 text-yellow-600 mb-4 animate-pulse" />
//             <h3 className="text-xl font-bold text-black mb-2">Advanced Skills</h3>
//             <p className="text-gray-700">
//               Master OOP, frameworks, APIs, security, and deployment techniques.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose PHP */}
//       <section className="py-20 px-6 md:px-20 bg-gray-50">
//         <h2
//           className="text-4xl font-bold text-center text-black mb-12"
//           data-aos="fade-up"
//         >
//           Why Choose PHP?
//         </h2>
//         <ul
//           className="max-w-3xl mx-auto space-y-4 text-lg text-gray-700"
//           data-aos="fade-up"
//         >
//           <li className="flex items-center gap-3 animate-bounce">
//             <CheckCircle2 className="text-green-600 animate-pulse" /> Widely used
//             for global web development.
//           </li>
//           <li className="flex items-center gap-3 animate-shake">
//             <Database className="text-indigo-600 animate-spin-slow" /> Seamlessly
//             integrates with MySQL, MariaDB, and more.
//           </li>
//           <li className="flex items-center gap-3 animate-jump">
//             <Workflow className="text-pink-600 animate-bounce" /> Ideal for
//             building interactive websites.
//           </li>
//           <li className="flex items-center gap-3 animate-bounce">
//             <Server className="text-yellow-600 animate-pulse" /> Supports
//             Laravel, CodeIgniter, and modern frameworks.
//           </li>
//           <li className="flex items-center gap-3 animate-shake">
//             <Shield className="text-purple-600 animate-spin-slow" /> Real-world
//             projects with secure, scalable solutions.
//           </li>
//         </ul>
//       </section>

//       {/* Footer CTA */}
//       <footer className="bg-gradient-to-r from-purple-700 to-indigo-800 text-white py-12 px-6 text-center">
//         <h2 className="text-3xl font-bold mb-4 animate-fade-in">
//           Ready to Kickstart Your PHP Career?
//         </h2>
//         <p className="mb-6 opacity-90 text-lg">
//           Enroll today and become a professional PHP Developer with hands-on
//           projects and real-world skills.
//         </p>
//         <a
//           href="/contact"
//           className="inline-block bg-yellow-400 text-black px-8 py-3 rounded-xl font-semibold shadow-lg hover:bg-yellow-500 transition transform hover:scale-110 animate-bounce"
//         >
//           🚀 Enroll Now
//         </a>
//       </footer>
//     </div>
//   );
// };

// export default PHPProgramming;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Code,
  Database,
  Layers,
  Rocket,
  Shield,
  Workflow,
  Users,
  Terminal,
  Server,
  CheckCircle2,
  GraduationCap,
  Star,
  BookOpen,
} from "lucide-react";
import { Link } from "react-router-dom";

const PHPProgramming = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: false });
  }, []);

  return (
    <div className="overflow-hidden">
      {/* Hero Section */}
      <section
        className="relative text-white py-20 px-6 md:px-20 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('../assets/blue-and-red-color-gradient-background-free-vector.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-800/80 via-purple-800/70 to-pink-700/80"></div>
        <div className="relative flex flex-col md:flex-row items-center gap-10">
          <div className="md:w-1/2" data-aos="fade-right">
            <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6 text-yellow-300 animate-bounce mt-5">
              Master PHP Programming
            </h1>
            <p className="text-lg md:text-xl mb-8 text-gray-100">
              Learn PHP from scratch to advanced concepts. Build dynamic
              websites, work with databases, and develop professional web
              applications that power the internet.
            </p>
            <Link>
              <button className="bg-yellow-400 hover:bg-yellow-500 text-black px-8 py-3 rounded-xl font-semibold shadow-lg transition-transform transform hover:scale-110 animate-pulse">
                🚀 Enroll Now
              </button>
            </Link>
          </div>
          <div className="md:w-1/2" data-aos="fade-left">
            <img
              src="../assets/php-coding-concept-programmer-search-technology-background-photo.jpg"
              alt="PHP Programming"
              className="rounded-2xl shadow-2xl animate-float"
            />
          </div>
        </div>
      </section>

      {/* What is PHP */}
      <section className="py-20 px-6 md:px-20 bg-gray-50 flex justify-center">
        <div
          className="bg-indigo-50 shadow-lg rounded-2xl p-8 max-w-4xl transition-transform transform hover:-translate-y-2 hover:shadow-2xl animate-fade-in"
          data-aos="fade-up"
        >
          <h2 className="text-4xl font-bold text-center text-black mb-8">
            What is PHP Programming?
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed text-justify">
            <span className="font-semibold text-purple-700">PHP</span>{" "}
            (Hypertext Preprocessor) is a powerful server-side scripting
            language widely used for web development. It powers millions of
            websites and applications, enabling developers to create dynamic
            content, manage databases, and build scalable web solutions. This
            course takes you from beginner to professional, covering basics,
            advanced topics, and frameworks like{" "}
            <span className="text-indigo-700 font-semibold">Laravel</span>.
          </p>
        </div>
      </section>

      {/* Course Outcomes */}
      <section className="py-20 px-6 md:px-20 bg-gradient-to-r from-gray-100 via-gray-50 to-white">
        <h2
          className="text-4xl font-bold text-center text-black mb-14"
          data-aos="zoom-in"
        >
          Course Outcomes
        </h2>
        <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          <div
            className="bg-blue-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-bounce"
            data-aos="flip-left"
          >
            <Code className="mx-auto w-12 h-12 text-indigo-600 mb-4 animate-spin-slow" />
            <h3 className="text-xl font-bold text-black mb-2">
              Hands-on Projects
            </h3>
            <p className="text-gray-700">
              Build dynamic websites and web applications using PHP and MySQL.
            </p>
          </div>
          <div
            className="bg-pink-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-jump"
            data-aos="flip-up"
          >
            <Rocket className="mx-auto w-12 h-12 text-pink-600 mb-4 animate-bounce" />
            <h3 className="text-xl font-bold text-black mb-2">Career Ready</h3>
            <p className="text-gray-700">
              Prepare for roles like PHP Developer, Backend Engineer, and Full
              Stack Web Developer.
            </p>
          </div>
          <div
            className="bg-yellow-100 shadow-xl p-8 rounded-2xl text-center hover:shadow-2xl hover:-translate-y-2 transition-transform animate-shake"
            data-aos="flip-right"
          >
            <Layers className="mx-auto w-12 h-12 text-yellow-600 mb-4 animate-pulse" />
            <h3 className="text-xl font-bold text-black mb-2">
              Advanced Skills
            </h3>
            <p className="text-gray-700">
              Master OOP, frameworks, APIs, security, and deployment techniques.
            </p>
          </div>
        </div>
      </section>

      {/* New Section: Course Curriculum */}
      <section className="py-20 px-6 md:px-20 bg-gray-50">
        <h2
          className="text-4xl font-bold text-center text-black mb-12"
          data-aos="zoom-in"
        >
          Course Curriculum
        </h2>
        <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {[
            {
              icon: Terminal,
              title: "PHP Basics",
              desc: "Syntax, variables, loops & functions",
              gradient: "linear-gradient(135deg, #e0f7fa, #b2ebf2)",
            },
            {
              icon: Database,
              title: "Database Mastery",
              desc: "MySQL CRUD, relationships, indexing",
              gradient: "linear-gradient(135deg, #fff3e0, #ffe0b2)",
            },
            {
              icon: BookOpen,
              title: "OOP in PHP",
              desc: "Classes, inheritance, polymorphism",
              gradient: "linear-gradient(135deg, #f3e5f5, #e1bee7)",
            },
            {
              icon: Server,
              title: "Web Development",
              desc: "Sessions, cookies, authentication",
              gradient: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
            },
            {
              icon: Shield,
              title: "Security",
              desc: "SQL Injection prevention, XSS, CSRF",
              gradient: "linear-gradient(135deg, #fffde7, #fff9c4)",
            },
            {
              icon: Rocket,
              title: "Frameworks",
              desc: "Laravel & modern PHP practices",
              gradient: "linear-gradient(135deg, #e1f5fe, #b3e5fc)",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="shadow-md rounded-xl p-8 text-center hover:shadow-2xl hover:-translate-y-2 transition-transform"
              data-aos="fade-up"
              style={{ background: item.gradient }}
            >
              <item.icon className="mx-auto w-12 h-12 text-purple-600 mb-4 animate-bounce" />
              <h3 className="text-xl font-bold text-black mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* New Section: Who Can Join */}
      <section className="py-20 px-6 md:px-20 bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50">
        <h2
          className="text-4xl font-bold text-center text-black mb-12"
          data-aos="fade-up"
        >
          Who Can Join?
        </h2>
        <ul
          className="max-w-3xl mx-auto space-y-4 text-lg text-gray-700"
          data-aos="fade-up"
        >
          <li className="flex items-center gap-3 animate-bounce">
            <GraduationCap className="text-indigo-600 animate-pulse" /> Students
            aspiring to become web developers.
          </li>
          <li className="flex items-center gap-3 animate-shake">
            <Users className="text-pink-600 animate-spin-slow" /> Beginners with
            no coding background.
          </li>
          <li className="flex items-center gap-3 animate-jump">
            <Star className="text-yellow-600 animate-bounce" /> Professionals
            upgrading their backend skills.
          </li>
        </ul>
      </section>

      {/* New Section: Testimonials */}
      {/* <section className="py-20 px-6 md:px-20 bg-gray-50">
        <h2
          className="text-4xl font-bold text-center text-black mb-12"
          data-aos="zoom-in"
        >
          What Our Students Say
        </h2>
        <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {[
            {
              name: "Arjun R",
              quote:
                "This PHP course transformed my career. I landed a job as a Backend Developer within 2 months of completion!",
            },
            {
              name: "Meera S",
              quote:
                "The projects were amazing. I built a full-fledged e-commerce site using Laravel and PHP.",
            },
          ].map((student, i) => (
            <div
              key={i}
              className="bg-white shadow-lg rounded-2xl p-8 hover:-translate-y-2 transition-transform"
              data-aos="fade-up"
            >
              <p className="text-gray-700 italic mb-4">“{student.quote}”</p>
              <h4 className="text-lg font-bold text-purple-700">
                {student.name}
              </h4>
            </div>
          ))}
        </div>
      </section> */}

      {/* Why Choose PHP */}
      <section className="py-20 px-6 md:px-20 bg-gray-50">
        <h2
          className="text-4xl font-bold text-center text-black mb-12"
          data-aos="fade-up"
        >
          Why Choose PHP?
        </h2>
        <ul
          className="max-w-3xl mx-auto space-y-4 text-lg text-gray-700"
          data-aos="fade-up"
        >
          <li className="flex items-center gap-3 animate-bounce">
            <CheckCircle2 className="text-green-600 animate-pulse" /> Widely
            used for global web development.
          </li>
          <li className="flex items-center gap-3 animate-shake">
            <Database className="text-indigo-600 animate-spin-slow" />{" "}
            Seamlessly integrates with MySQL, MariaDB, and more.
          </li>
          <li className="flex items-center gap-3 animate-jump">
            <Workflow className="text-pink-600 animate-bounce" /> Ideal for
            building interactive websites.
          </li>
          <li className="flex items-center gap-3 animate-bounce">
            <Server className="text-yellow-600 animate-pulse" /> Supports
            Laravel, CodeIgniter, and modern frameworks.
          </li>
          <li className="flex items-center gap-3 animate-shake">
            <Shield className="text-purple-600 animate-spin-slow" /> Real-world
            projects with secure, scalable solutions.
          </li>
        </ul>
      </section>

      {/* Footer CTA */}
      <footer className="bg-gradient-to-r from-purple-700 to-indigo-800 text-white py-12 px-6 text-center">
        <h2 className="text-3xl font-bold mb-4 animate-fade-in">
          Ready to Kickstart Your PHP Career?
        </h2>
        <p className="mb-6 opacity-90 text-lg">
          Enroll today and become a professional PHP Developer with hands-on
          projects and real-world skills.
        </p>
        <Link
          to="/contact"
          className="inline-block bg-yellow-400 text-black px-8 py-3 rounded-xl font-semibold shadow-lg hover:bg-yellow-500 transition transform hover:scale-110 animate-bounce"
        >
          🚀 Enroll Now
        </Link>
      </footer>
    </div>
  );
};

export default PHPProgramming;
